import * as t from 'io-ts';
import { ModelIdData, ModelDerivedData, ModelTenant } from '../base';
/** A complete model summary item as stored in DynamoDB modelsByTenant index */
export const Data = t.intersection([
    t.exact(ModelIdData),
    t.exact(ModelDerivedData),
    t.exact(ModelTenant),
]);
